module.exports = __webpack_public_path__ + "img/hr-long-handed-inserter-hand-closed.e699b0e6.png";